import { Link, Typography } from '@one-thd/sui-atomic-components';
import React from 'react';
export var HelpDialogBox = function () {
    return (React.createElement("div", { className: "sui-mx-2 sm:sui-ms-10 md:sui-mx-40 xl:sui-mx-0", style: {
            border: '1px solid #CCC',
        } },
        React.createElement("div", { className: "sui-flex sui-p-1 sui-mb-[5px]" },
            React.createElement("img", { src: "https://assets.thdstatic.com/images/v1/StoreAssociate.svg", alt: "Store associate", width: "25px", height: "25px", style: { marginRight: '10px' } }),
            React.createElement(Typography, { variant: "h5" },
                "Questions About Your Order?",
                React.createElement("br", null),
                " We're Here to help")),
        React.createElement("div", { className: "sui-flex sui-flex-row sui-flex-wrap sui-gap-2 sui-p-1" },
            React.createElement("div", { className: "sui-w-full" },
                React.createElement(Typography, { variant: "body-base" },
                    "See our",
                    ' ',
                    React.createElement(Link, { href: "https://www.homedepot.com/c/customer_service" }, "Online FAQs"),
                    ", or call us:")),
            React.createElement("div", { className: "sui-w-full" },
                React.createElement(Typography, { variant: "body-base" }, "Online Orders: 1-800-430-3376")),
            React.createElement("div", { className: "sui-w-full" },
                React.createElement(Typography, { variant: "body-base" }, "In-Store Purchases: 1-800-HOME-DEPOT (466-3337)")),
            React.createElement("div", { className: "sui-w-full" },
                React.createElement(Typography, { variant: "body-base" }, "Major Appliances: 1-877-946-9843")),
            React.createElement("div", { className: "sui-w-full" },
                React.createElement(Typography, { variant: "body-base" },
                    "We're available from ",
                    React.createElement("strong", null, "6 a.m. to 2 a.m."),
                    " EST, 7 days a week.")))));
};
